(function () {
  const root = document.getElementById("nuvra-seller-hub");
  if (!root) return;

  const CANONICAL_API = "https://admin-uploader-psi.vercel.app";

  function resolveSellerApiBase(configured) {
    let base = (configured || "").replace(/\/$/, "");
    if (!base) return CANONICAL_API;
    if (
      base.indexOf("studio.nuvrasupplyco.com") >= 0 ||
      base.indexOf("nuvra-studio.vercel.app") >= 0
    ) {
      return CANONICAL_API;
    }
    return base;
  }

  const API_BASE = resolveSellerApiBase(root.dataset.apiBase);
  const MODE = root.dataset.mode || "dashboard";
  const TOKEN_KEY = "nuvra_creator_token";
  const EMAIL_KEY = "nuvra_seller_email";
  const customerEmail = root.dataset.customerEmail || "";
  const customerId = root.dataset.customerId || "";
  const loginUrl = root.dataset.loginUrl || "/account/login";
  const registerUrl = root.dataset.registerUrl || "/account/register";
  const accountUrl = root.dataset.accountUrl || "/account";
  const searchUrl = root.dataset.searchUrl || "/search";

  const PAGES = {
    dashboard: "/?view=seller-dashboard",
    "build-shop": "/?view=build-my-shop",
    "list-design": "/?view=list-design",
    favorites: "/?view=favorites",
  };

  const NAV_ITEMS = [
    { key: "dashboard", label: "My Shop", short: "Shop" },
    { key: "build-shop", label: "Build Shop", short: "Build" },
    { key: "list-design", label: "List Design", short: "List" },
    { key: "favorites", label: "Favorites", short: "Saved" },
  ];

  const STOREFRONT_HOME = "/?view=live";

  function studioHandoff(path, authToken) {
    const t = authToken || token();
    if (!t) return API_BASE + path;
    const join = path.indexOf("?") >= 0 ? "&" : "?";
    return API_BASE + path + join + "handoff=" + encodeURIComponent(t);
  }


  if (!API_BASE && MODE !== "public-shop") {
    root.innerHTML =
      '<div class="nuvra-seller-hub__error">Seller hub is not configured yet. Set the API URL in theme settings.</div>';
    return;
  }

  function token() {
    return localStorage.getItem(TOKEN_KEY);
  }

  if (MODE === "dashboard" && token()) {
    window.location.replace(studioHandoff("/seller/dashboard"));
    return;
  }

  function setToken(value) {
    if (value) localStorage.setItem(TOKEN_KEY, value);
    else localStorage.removeItem(TOKEN_KEY);
    try {
      window.dispatchEvent(new CustomEvent("nuvra:seller-auth-changed"));
    } catch (_) {
      /* ignore */
    }
  }

  async function api(path, options = {}) {
    const headers = { ...(options.headers || {}) };
    const t = token();
    if (t) headers.Authorization = "Bearer " + t;
    let res;
    try {
      res = await fetch(API_BASE + path, { ...options, headers });
    } catch (e) {
      throw new Error(
        "Could not reach the seller server. Check your connection and try again."
      );
    }
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || "Request failed");
    return data;
  }

  function esc(str) {
    const d = document.createElement("div");
    d.textContent = str == null ? "" : String(str);
    return d.innerHTML;
  }

  function navHtml(active) {
    var links = NAV_ITEMS.map(function (item) {
      const href = PAGES[item.key];
      const cls = active === item.key ? " is-active" : "";
      return '<a href="' + esc(href) + '" class="' + cls + '">' + item.label + "</a>";
    }).join("");
    links +=
      '<a href="' +
      esc(accountUrl) +
      '">Orders</a>' +
      '<a href="' +
      esc(STOREFRONT_HOME) +
      '">Return to Nuvra</a>';
    return '<nav class="nuvra-seller-hub__nav" aria-label="Seller hub">' + links + "</nav>";
  }

  function bottomNavHtml(active) {
    var items = NAV_ITEMS.map(function (item) {
      const href = PAGES[item.key];
      const cls = active === item.key ? " is-active" : "";
      return (
        '<a href="' +
        esc(href) +
        '" class="nuvra-seller-hub__bottom-link' +
        cls +
        '">' +
        esc(item.short) +
        "</a>"
      );
    }).join("");
    items +=
      '<a href="' +
      esc(accountUrl) +
      '" class="nuvra-seller-hub__bottom-link">Orders</a>' +
      '<a href="' +
      esc(STOREFRONT_HOME) +
      '" class="nuvra-seller-hub__bottom-link nuvra-seller-hub__bottom-link--nuvra">Nuvra</a>';
    return (
      '<nav class="nuvra-seller-hub__bottom-nav" aria-label="Seller hub">' +
      items +
      "</nav>"
    );
  }

  function hubShellHtml(active, innerHtml) {
    return (
      '<div class="nuvra-seller-hub">' +
      navHtml(active) +
      innerHtml +
      bottomNavHtml(active) +
      "</div>"
    );
  }

  function setAuthOnlyLayout(isAuthOnly) {
    const section = root.closest(".nuvra-seller-hub-section");
    if (section) {
      section.classList.toggle("nuvra-seller-hub-section--auth-only", isAuthOnly);
    }
  }

  function renderGate(message) {
    renderAuthPanel(message);
  }

  function renderAuthPanel(gateMessage) {
    setAuthOnlyLayout(true);
    const savedEmail = localStorage.getItem(EMAIL_KEY) || customerEmail || "";

    root.innerHTML = hubShellHtml(
      MODE,
      '<div class="nuvra-seller-hub__gate">' +
      '<h2 class="nuvra-display nuvra-seller-hub__gate-title">' +
      esc(gateMessage || "Sell with Nuvra") +
      "</h2>" +
      "<p>Log in or create your seller account. Your login is saved on this device so you can return anytime.</p>" +
      '<div class="nuvra-seller-hub__field"><label>Email</label><input type="email" id="seller-email" autocomplete="email" placeholder="you@example.com" value="' +
      esc(savedEmail) +
      '"></div>' +
      '<div class="nuvra-seller-hub__field"><label>Password</label><input type="password" id="seller-password" autocomplete="current-password" placeholder="At least 8 characters"></div>' +
      '<div id="seller-auth-error" class="nuvra-seller-hub__error" hidden></div>' +
      '<div class="nuvra-seller-hub__auth-actions">' +
      '<button type="button" class="nuvra-btn nuvra-btn--primary" id="btn-seller-login">Log In</button>' +
      '<button type="button" class="nuvra-btn nuvra-btn--ghost" id="btn-seller-register">Create Account</button>' +
      "</div>" +
      '<p class="nuvra-seller-hub__hint" style="margin-top:16px;text-align:center;">' +
      "Need a Nuvra store account for orders? " +
      '<a href="' +
      esc(loginUrl) +
      "?return_url=" +
      encodeURIComponent(window.location.pathname + window.location.search) +
      '">Sign in to the store</a> (optional).</p>' +
      "</div>"
    );

    function showError(text) {
      const err = document.getElementById("seller-auth-error");
      err.textContent = text;
      err.hidden = false;
    }

    function clearError() {
      const err = document.getElementById("seller-auth-error");
      err.hidden = true;
    }

    function getCredentials() {
      const email = document.getElementById("seller-email").value.trim();
      const password = document.getElementById("seller-password").value;
      if (!email) throw new Error("Enter your email address.");
      if (!password) throw new Error("Enter your password.");
      if (password.length < 8) throw new Error("Password must be at least 8 characters.");
      return { email, password };
    }

    async function afterAuth(data) {
      setToken(data.token);
      localStorage.setItem(EMAIL_KEY, data.user?.email || document.getElementById("seller-email").value.trim().toLowerCase());
      await boot();
    }

    document.getElementById("btn-seller-login").addEventListener("click", async function () {
      clearError();
      try {
        const creds = getCredentials();
        const data = await api("/api/creator/login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(creds),
        });
        await afterAuth(data);
      } catch (e) {
        showError(e.message);
      }
    });

    document.getElementById("btn-seller-register").addEventListener("click", async function () {
      clearError();
      try {
        const creds = getCredentials();
        const data = await api("/api/creator/register", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: creds.email,
            password: creds.password,
            displayName: creds.email.split("@")[0] || "Seller",
            shopifyCustomerId: customerId || undefined,
          }),
        });
        setToken(data.token);
        localStorage.setItem(EMAIL_KEY, creds.email.toLowerCase());
        window.location.href = studioHandoff("/studio", data.token);
      } catch (e) {
        showError(e.message);
      }
    });
  }

  function statusBadge(status) {
    const cls =
      status === "live"
        ? "nuvra-seller-hub__badge--live"
        : status === "draft"
          ? "nuvra-seller-hub__badge--draft"
          : status === "rejected"
            ? "nuvra-seller-hub__badge--rejected"
            : "nuvra-seller-hub__badge--pending";
    const label = status === "draft" ? "draft" : status;
    return '<span class="nuvra-seller-hub__badge ' + cls + '">' + esc(label) + "</span>";
  }

  function listingPreviewHtml(l) {
    if (l.mockupUrl) {
      return (
        '<div class="nuvra-seller-hub__listing-media">' +
        '<img src="' +
        esc(l.mockupUrl) +
        '" alt="" class="nuvra-seller-hub__listing-thumb" loading="lazy" decoding="async">' +
        "</div>"
      );
    }
    return (
      '<div class="nuvra-seller-hub__listing-media nuvra-seller-hub__listing-media--empty">' +
      '<div class="nuvra-seller-hub__listing-thumb nuvra-seller-hub__listing-thumb--empty">Preview coming soon</div>' +
      "</div>"
    );
  }

  function listingCardHtml(l, opts) {
    opts = opts || {};
    const isLive = l.status === "live";
    const productHref =
      isLive && l.shopifyHandle ? "/products/" + encodeURIComponent(l.shopifyHandle) : "";
    const draftClass = l.status === "draft" ? " nuvra-seller-hub__listing-card--draft" : "";
    const metaParts = [];
    if (opts.showCategory !== false && l.category) metaParts.push(esc(l.category));
    if (opts.showHandle && l.sellerHandle) metaParts.push("@" + esc(l.sellerHandle));
    metaParts.push("$" + esc(Number(l.price).toFixed(2)));
    const meta = metaParts.join(" · ");
    const badge = opts.showBadge !== false ? statusBadge(l.status) : "";
    const body =
      '<div class="nuvra-seller-hub__listing-body">' +
      '<p class="nuvra-seller-hub__listing-title">' +
      esc(l.title) +
      "</p>" +
      '<p class="nuvra-seller-hub__listing-meta">' +
      meta +
      "</p>" +
      badge +
      "</div>";
    const cardInner = listingPreviewHtml(l) + body;
    const shareHtml =
      isLive && l.shopifyHandle && window.NuvraSocialShare
        ? window.NuvraSocialShare.buttonsHtml(l)
        : "";

    if (productHref) {
      return (
        '<article class="nuvra-seller-hub__listing-card' +
        draftClass +
        '">' +
        '<a href="' +
        esc(productHref) +
        '" class="nuvra-seller-hub__listing-link">' +
        cardInner +
        "</a>" +
        shareHtml +
        "</article>"
      );
    }
    return (
      '<article class="nuvra-seller-hub__listing-card' + draftClass + '">' + cardInner + "</article>"
    );
  }

  function bindListingShare(listings) {
    if (!window.NuvraSocialShare || !listings || !listings.length) return;
    var byId = {};
    listings.forEach(function (l) {
      byId[l.id] = l;
    });
    window.NuvraSocialShare.bind(root, byId);
  }

  function listingsGridHtml(listings, opts) {
    return (
      '<div class="nuvra-seller-hub__listings nuvra-seller-hub__listings--grid">' +
      listings
        .map(function (l) {
          return listingCardHtml(l, opts);
        })
        .join("") +
      "</div>"
    );
  }

  async function renderDashboard(data) {
    setAuthOnlyLayout(false);
    const profile = data.profile;
    const credit = data.shopCredit || data.earnings || { totalSales: 0, shopCreditBalance: 0, totalEarned: 0 };
    const creditBalance = credit.shopCreditBalance ?? credit.totalEarned ?? 0;
    const listings = data.listings || [];
    const pricing = data.pricing || { fixedPrice: 24.99, shopCreditPerSale: 4.99, earningsPerSale: 4.99 };
    const creditPerSale = pricing.shopCreditPerSale ?? pricing.earningsPerSale ?? 4.99;
    const creditPerSaleLabel = Number(creditPerSale).toFixed(2);
    const accountLine = customerEmail
      ? "Shop credit is linked to <strong>" + esc(customerEmail) + "</strong>."
      : "Shop credit is saved to your seller account.";

    if (!profile) {
      root.innerHTML = hubShellHtml(
        MODE,
        '<div class="nuvra-seller-hub__gate">' +
        "<h2 class=\"nuvra-display\" style=\"font-size:1.4rem;margin:0 0 12px;\">Start Designing</h2>" +
        "<p>Set up your shop, upload designs, then open the design studio to put art on a shirt.</p>" +
        '<a href="' +
        esc(PAGES["build-shop"]) +
        '" class="nuvra-btn nuvra-btn--ghost">Set Up My Shop</a> ' +
        '<a href="' +
        esc(studioHandoff("/seller/library")) +
        '" class="nuvra-btn nuvra-btn--primary">Upload Designs</a> ' +
        '<a href="' +
        esc(studioHandoff("/studio")) +
        '" class="nuvra-btn nuvra-btn--primary">Design Studio</a>' +
        "</div>"
      );
      return;
    }

    const listingsHtml =
      listings.length === 0
        ? '<p class="nuvra-seller-hub__empty">No listings yet. <a href="' +
          esc(studioHandoff("/seller/library")) +
          '">Upload designs</a> or <a href="' +
          esc(studioHandoff("/studio")) +
          '">open the design studio</a>.</p>'
        : listingsGridHtml(listings, { showCategory: false, showHandle: true });

    root.innerHTML = hubShellHtml(
      MODE,
      '<div class="nuvra-seller-hub__card">' +
      "<p style=\"margin:0 0 8px;\">Welcome back, <strong>@" +
      esc(profile.handle) +
      "</strong></p>" +
      "<p style=\"color:#888;margin:0 0 20px;font-size:0.9rem;\">" +
      esc(profile.shopName) +
      (profile.bio ? " — " + esc(profile.bio) : "") +
      "</p>" +
      '<div class="nuvra-seller-hub__stats">' +
      '<div class="nuvra-seller-hub__stat"><span class="nuvra-seller-hub__stat-value">$' +
      esc(Number(creditBalance).toFixed(2)) +
      '</span><span class="nuvra-seller-hub__stat-label">Shop Credit</span></div>' +
      '<div class="nuvra-seller-hub__stat"><span class="nuvra-seller-hub__stat-value">' +
      esc(credit.totalSales) +
      '</span><span class="nuvra-seller-hub__stat-label">Items Sold</span></div>' +
      '<div class="nuvra-seller-hub__stat"><span class="nuvra-seller-hub__stat-value">$' +
      esc(creditPerSaleLabel) +
      '</span><span class="nuvra-seller-hub__stat-label">Credit Per Item</span></div>' +
      '<div class="nuvra-seller-hub__stat"><span class="nuvra-seller-hub__stat-value">$' +
      esc(Number(pricing.fixedPrice).toFixed(2)) +
      '</span><span class="nuvra-seller-hub__stat-label">Shirt Price</span></div>' +
      "</div>" +
      '<p style="font-size:0.85rem;color:#888;margin:0 0 8px;">Every shirt sells for $' +
      esc(Number(pricing.fixedPrice).toFixed(2)) +
      ". You earn $" +
      esc(creditPerSaleLabel) +
      ' shop credit per item sold. Nuvra handles design polish, Printful fulfillment, and platform ops.</p>' +
      '<p style="font-size:0.85rem;color:#888;margin:0 0 16px;">' +
      accountLine +
      " Use credit on future Nuvra orders.</p>" +
      '<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:20px;">' +
      '<a href="' +
      esc(studioHandoff("/seller/library")) +
      '" class="nuvra-btn nuvra-btn--primary">Upload Designs</a>' +
      '<a href="' +
      esc(studioHandoff("/studio")) +
      '" class="nuvra-btn nuvra-btn--primary">Design Studio</a>' +
      '<a href="' +
      esc(studioHandoff("/seller/shop")) +
      '" class="nuvra-btn nuvra-btn--ghost">My Shop Settings</a>' +
      '<a href="/?view=seller-shop&handle=' +
      encodeURIComponent(profile.handle) +
      '" class="nuvra-btn nuvra-btn--ghost">View Public Shop</a>' +
      "</div>" +
      "<h3 class=\"nuvra-display\" style=\"font-size:1.1rem;margin:0 0 12px;\">Your Listings</h3>" +
      listingsHtml +
      "</div>"
    );
    bindListingShare(listings);
  }

  async function renderBuildShop(data) {
    setAuthOnlyLayout(false);
    const profile = data.profile;
    root.innerHTML = hubShellHtml(
      MODE,
      '<div class="nuvra-seller-hub__card">' +
      "<h2 class=\"nuvra-display\" style=\"font-size:1.3rem;margin:0 0 8px;\">Build My Shop</h2>" +
      "<p style=\"color:#888;margin:0 0 20px;\">Customize your seller page — your @handle, shop name, and bio show on Seller Shops and every product you sell.</p>" +
      '<div class="nuvra-seller-hub__field"><label>Shop Handle (@username)</label><input type="text" id="shop-handle" placeholder="e.g. bannedmom" value="' +
      esc(profile ? profile.handle : "") +
      '"><p class="nuvra-seller-hub__hint">Letters, numbers, underscores only. Min 3 characters.</p></div>' +
      '<div class="nuvra-seller-hub__field"><label>Shop Name</label><input type="text" id="shop-name" placeholder="Your shop display name" value="' +
      esc(profile ? profile.shopName : "") +
      '"></div>' +
      '<div class="nuvra-seller-hub__field"><label>Bio</label><textarea id="shop-bio" placeholder="What kind of designs do you drop?">' +
      esc(profile ? profile.bio : "") +
      "</textarea></div>" +
      '<div id="shop-error" class="nuvra-seller-hub__error" hidden></div>' +
      '<div id="shop-success" class="nuvra-seller-hub__success" hidden></div>' +
      '<button type="button" class="nuvra-btn nuvra-btn--primary" id="btn-save-shop">Save My Shop</button>' +
      "</div>"
    );

    document.getElementById("btn-save-shop").addEventListener("click", async function () {
      const err = document.getElementById("shop-error");
      const ok = document.getElementById("shop-success");
      err.hidden = true;
      ok.hidden = true;
      try {
        const result = await api("/api/seller/shop", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            handle: document.getElementById("shop-handle").value,
            shopName: document.getElementById("shop-name").value,
            bio: document.getElementById("shop-bio").value,
            shopifyCustomerId: customerId,
          }),
        });
        ok.textContent = "Shop saved! @" + result.profile.handle + " is live.";
        ok.hidden = false;
        setTimeout(function () {
          window.location.href = studioHandoff("/studio");
        }, 1200);
      } catch (e) {
        err.textContent = e.message;
        err.hidden = false;
      }
    });
  }

  async function renderListDesign(data) {
    setAuthOnlyLayout(false);
    if (!data.profile) {
      root.innerHTML = hubShellHtml(
        MODE,
        '<div class="nuvra-seller-hub__gate">' +
        "<p>Upload and design your tee first. Shop details are collected when you publish.</p>" +
        '<a href="' +
        esc(studioHandoff("/studio")) +
        '" class="nuvra-btn nuvra-btn--primary">Open Design Studio</a>' +
        "</div>"
      );
      return;
    }

    const pricing = data.pricing || { fixedPrice: 24.99, shopCreditPerSale: 4.99, earningsPerSale: 4.99 };
    const creditPerSale = pricing.shopCreditPerSale ?? pricing.earningsPerSale ?? 4.99;
    const creditPerSaleLabel = Number(creditPerSale).toFixed(2);

    root.innerHTML = hubShellHtml(
      MODE,
      '<div class="nuvra-seller-hub__card">' +
      "<h2 class=\"nuvra-display\" style=\"font-size:1.3rem;margin:0 0 8px;\">List New Design</h2>" +
      "<p style=\"color:#888;margin:0 0 12px;\">Listing as <strong>@" +
      esc(data.profile.handle) +
      "</strong></p>" +
      '<span class="nuvra-seller-hub__price-pill">Fixed price: $' +
      esc(Number(pricing.fixedPrice).toFixed(2)) +
      " · $" +
      esc(creditPerSaleLabel) +
      " shop credit per item sold</span>" +
      '<form id="list-form">' +
      '<div class="nuvra-seller-hub__field"><label>Design Title</label><input type="text" name="title" required placeholder="E.g. Based Mom Energy"></div>' +
      '<div class="nuvra-seller-hub__field"><label>Category</label><select name="category">' +
      '<option value="meme">Meme / Parody</option>' +
      '<option value="gym">Gym</option>' +
      '<option value="mom">Mom Life</option>' +
      '<option value="political">Politically Incorrect</option>' +
      '<option value="conservative">Based Conservative</option>' +
      '<option value="other">Other</option>' +
      "</select></div>" +
      '<div class="nuvra-seller-hub__field"><label>Description (optional)</label><textarea name="description" placeholder="Tell us about the vibe, colors, or placement."></textarea></div>' +
      '<div class="nuvra-seller-hub__field"><label>Design File</label><input type="file" name="design" accept="image/png,image/jpeg,image/svg+xml,image/webp,application/pdf" required></div>' +
      '<div id="list-error" class="nuvra-seller-hub__error" hidden></div>' +
      '<div id="list-success" class="nuvra-seller-hub__success" hidden></div>' +
      '<button type="submit" class="nuvra-btn nuvra-btn--primary">Publish Design</button>' +
      "</form>" +
      "<p class=\"nuvra-seller-hub__hint\" style=\"margin-top:16px;\">Your design goes live on your shop as soon as you publish it.</p>" +
      "</div>"
    );

    document.getElementById("list-form").addEventListener("submit", async function (e) {
      e.preventDefault();
      const err = document.getElementById("list-error");
      const ok = document.getElementById("list-success");
      err.hidden = true;
      ok.hidden = true;
      const form = e.target;
      const fd = new FormData(form);
      try {
        const result = await api("/api/seller/listings", { method: "POST", body: fd });
        ok.textContent = result.message || "Design submitted!";
        ok.hidden = false;
        form.reset();
      } catch (ex) {
        err.textContent = ex.message;
        err.hidden = false;
      }
    });
  }

  async function renderFavorites() {
    setAuthOnlyLayout(false);
    let favorites = { shopHandles: [], productHandles: [] };
    try {
      const data = await api("/api/seller/favorites");
      favorites = data.favorites || favorites;
    } catch (_) {
      /* empty favorites ok */
    }

    const shops =
      favorites.shopHandles.length === 0
        ? "<p class=\"nuvra-seller-hub__empty\">No favorite shops yet. Browse the marketplace and follow creators.</p>"
        : "<ul>" +
          favorites.shopHandles
            .map(function (h) {
              return (
                '<li style="margin-bottom:8px;"><a href="/?view=seller-shop&handle=' +
                encodeURIComponent(h) +
                '">@' +
                esc(h) +
                "</a></li>"
              );
            })
            .join("") +
          "</ul>";

    const products =
      favorites.productHandles.length === 0
        ? "<p class=\"nuvra-seller-hub__empty\">No saved products yet. Heart listings while you browse.</p>"
        : "<ul>" +
          favorites.productHandles
            .map(function (h) {
              return (
                '<li style="margin-bottom:8px;"><a href="/products/' +
                encodeURIComponent(h) +
                '">' +
                esc(h) +
                "</a></li>"
              );
            })
            .join("") +
          "</ul>";

    root.innerHTML = hubShellHtml(
      MODE,
      '<div class="nuvra-seller-hub__card">' +
      "<h2 class=\"nuvra-display\" style=\"font-size:1.3rem;margin:0 0 16px;\">Favorites</h2>" +
      "<h3 style=\"font-size:1rem;margin:0 0 8px;\">Favorite Shops</h3>" +
      shops +
      "<h3 style=\"font-size:1rem;margin:20px 0 8px;\">Saved Products</h3>" +
      products +
      "</div>"
    );
  }

  async function isOwnShopHandle(handle) {
    if (!token() || !handle) return false;
    try {
      const data = await api("/api/seller/dashboard");
      const ownHandle = data.profile && data.profile.handle;
      return !!ownHandle && ownHandle.toLowerCase() === String(handle).toLowerCase();
    } catch (_) {
      return false;
    }
  }

  async function renderPublicShop() {
    const params = new URLSearchParams(window.location.search);
    const handle = params.get("handle") || params.get("seller") || "";

    if (!handle) {
      root.innerHTML = hubShellHtml(
        MODE,
        '<div class="nuvra-seller-hub__empty">No shop specified. Try <a href="' +
          esc(searchUrl) +
          '?q=seller">browsing sellers</a>.</div>'
      );
      return;
    }

    try {
      const data = await api("/api/seller/public?handle=" + encodeURIComponent(handle));
      const p = data.profile;
      const listings = data.listings || [];
      const isOwnShop = data.isOwnerView || (await isOwnShopHandle(handle));
      const draftCount = listings.filter(function (l) {
        return l.status === "draft";
      }).length;

      const listingsHtml =
        listings.length === 0
          ? '<p class="nuvra-seller-hub__empty">' +
            (isOwnShop
              ? 'No listings yet. <a href="' +
                esc(studioHandoff("/studio")) +
                '">Open the design studio</a> to create one.'
              : 'No live listings yet. Check back soon or <a href="' +
                esc(data.searchUrl) +
                '">search their products</a>.') +
            "</p>"
          : listingsGridHtml(listings, { showCategory: true, showHandle: false });

      root.innerHTML = hubShellHtml(
        "dashboard",
        '<div class="nuvra-seller-hub__public-hero">' +
        "<h1 class=\"nuvra-display\" style=\"font-size:clamp(1.5rem,4vw,2.2rem);margin:0 0 8px;\">" +
        esc(p.shopName) +
        "</h1>" +
        '<p class="nuvra-seller-hub__handle">Designed &amp; Sold by @' +
        esc(p.handle) +
        "</p>" +
        (p.bio ? '<p style="color:#aaa;max-width:480px;margin:12px auto 0;">' + esc(p.bio) + "</p>" : "") +
        (isOwnShop
          ? ""
          : '<button type="button" class="nuvra-btn nuvra-btn--ghost nuvra-seller-hub__follow-btn" id="btn-follow-shop" data-handle="' +
            esc(p.handle) +
            '">★ Follow Shop</button>') +
        "</div>" +
        '<div class="nuvra-seller-hub__card">' +
        "<h2 class=\"nuvra-display\" style=\"font-size:1.1rem;margin:0 0 12px;\">Shop Listings</h2>" +
        (isOwnShop && draftCount > 0
          ? '<p class="nuvra-seller-hub__draft-note">You have draft designs in your seller dashboard — they are not shown on your public shop until you publish them.</p>'
          : "") +
        listingsHtml +
        '<p style="margin-top:16px;text-align:center;"><a href="' +
        esc(data.searchUrl) +
        '" class="nuvra-btn nuvra-btn--primary">Shop All Products</a></p>' +
        "</div>"
      );

      bindListingShare(listings);

      const followBtn = document.getElementById("btn-follow-shop");
      if (followBtn && token()) {
        followBtn.addEventListener("click", async function () {
          try {
            await api("/api/seller/favorites", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                action: "toggle",
                type: "shop",
                value: followBtn.dataset.handle,
              }),
            });
            followBtn.textContent = "★ Following";
          } catch (e) {
            alert(e.message);
          }
        });
      } else if (followBtn) {
        followBtn.addEventListener("click", function () {
          window.location.href =
            loginUrl + "?return_url=" + encodeURIComponent(window.location.pathname + window.location.search);
        });
      }
    } catch (e) {
      root.innerHTML = hubShellHtml(
        MODE,
        '<div class="nuvra-seller-hub__error">Shop not found. Double-check the @handle.</div>'
      );
    }
  }

  async function boot() {
    if (MODE === "public-shop") {
      await renderPublicShop();
      return;
    }

    if (!token()) {
      renderAuthPanel();
      return;
    }

    try {
      const data = await api("/api/seller/dashboard");

      if (MODE === "dashboard") await renderDashboard(data);
      else if (MODE === "build-shop") await renderBuildShop(data);
      else if (MODE === "list-design") await renderListDesign(data);
      else if (MODE === "favorites") await renderFavorites();
    } catch (e) {
      if (
        e.message &&
        (e.message.toLowerCase().includes("log in") ||
          e.message.toLowerCase().includes("session") ||
          e.message.toLowerCase().includes("expired"))
      ) {
        setToken(null);
        renderAuthPanel("Your session expired — log in again");
        return;
      }
      root.innerHTML = hubShellHtml(
        MODE,
        '<div class="nuvra-seller-hub__error">' + esc(e.message) + "</div>"
      );
    }
  }

  boot();
})();
